export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                // { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {
            name: 'Customers',
            // route: 'customers',
            // type: 'customer',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'Suppliers', route: 'suppliers', type: 'supplier' },
                // { name: 'Markets', route: 'markets', type: 'market' },
            ],
            iconClass: 'material-icons',
            iconName: 'contacts',
            color: 'navy',
        },
        {
            name: 'Logins',
            route: 'logins',
            type: 'login',

            // children: [
            //     { name: 'Approved', route: 'customers', type: 'customer' },
            // ],
            iconClass: 'material-icons',
            iconName: 'supervised_user_circle',
            color: 'navy',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                // { name: 'Product Attributes', route: 'product_attributes', type: 'product_attribute', shortcut: 'product_attribute/_' },
                { name: 'Categories', route: 'categories', type: 'category' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Accepted Options',
            route: 'accepted_options',
            type: 'accepted_option',
            iconClass: 'material-icons',
            iconName: 'thumb_up_alt',
            color: 'navy',
        },
        {
            name: 'Failed Reasons',
            route: 'failed_reasons',
            type: 'reason',
            iconClass: 'material-icons',
            iconName: 'sms_failed',
            color: 'navy',
        },
        {
            name: 'Terms',
            route: 'terms',
            type: 'term',
            iconClass: 'material-icons',
            iconName: 'list_alt',
            color: 'navy',
        },
        {
            name: 'Companies',
            route: 'companies',
            type: 'company',
            iconClass: 'material-icons',
            iconName: 'business',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
                { name: 'API Access', route: 'oauth_clients', shortcut: 'oauth_client/_', type: 'oauth_client' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            type: 'setting',
            route: 'settings',
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}


// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js